export default __webpack_public_path__ + "static/media/icn-chevron.ea38ca5c.svg";